/***
 *
 *   CUSTOM ICONS
 *   Glyphs the ui-reference uses (from lucide) that have no Feather
 *   equivalent. Drawn to Feather's conventions so they sit correctly beside
 *   the rest: 24x24 viewBox, no fill, currentColor stroke, 2px width, round
 *   caps and joins.
 *
 *   Register a glyph here and <Icon image="name" /> picks it up automatically —
 *   cheaper than pulling in a second icon package for a handful of shapes.
 *
 *   See docs/ui-refresh/ICONS.md for the lucide -> feather mapping.
 *
 **********/

// `chevrons-up-down` — lucide's sort affordance. Feather has chevrons-up and
// chevrons-down but not the paired vertical form.
const chevronsUpDown = ['M7 15l5 5 5-5', 'M7 9l5-5 5 5'];

// `grip-vertical` — lucide drag handle (six dots). Drawn as tiny circles via
// arc paths so CustomIcon can stay path-only.
const gripVertical = [
    'M9 5a1 1 0 1 0 0.01 0',
    'M9 12a1 1 0 1 0 0.01 0',
    'M9 19a1 1 0 1 0 0.01 0',
    'M15 5a1 1 0 1 0 0.01 0',
    'M15 12a1 1 0 1 0 0.01 0',
    'M15 19a1 1 0 1 0 0.01 0',
];

export const CUSTOM_ICONS = {
    'chevrons-up-down': chevronsUpDown,
    'grip-vertical': gripVertical,
};

export function CustomIcon(props) {
    const paths = CUSTOM_ICONS[props.image];
    if (!paths) return null;

    const size = props.size || 16;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={props.color || 'currentColor'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={props.className}
            onClick={props.onClick}
            aria-hidden="true"
            focusable="false">
            {paths.map((d) => (
                <path key={d} d={d} />
            ))}
        </svg>
    );
}
